export class NombreAdherents {
    static jsonMap = {
        nombreProducteursOrganises: { key: 'nombreProducteursOrganises' },
        nombreProducteursIndependants: { key: 'nombreProducteursIndependants' },
        nombreGroupementsProducteurs: { key: 'nombreGroupementsProducteurs' }
    };

    public nombreProducteursOrganises: number;
    public nombreProducteursIndependants: number;
    public nombreGroupementsProducteurs: number;
}
